import { createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl, headersDefault } from '.'
import { clearCache } from '../../services/functions'
import dayjs from 'dayjs'

// The CRM's "clear cache / log out" command only needs checking now and then.
// It was asked on every page change (Home's useIonViewDidEnter fires app-wide,
// and its 5-minute guard kept the first render's time) and on every feed
// refresh: the most refused call in the prod logs, using up the member's
// allowance so Home and the feed failed (07.10.2026). Guarded here, once per
// five minutes per app session, whoever calls it.
const CLEAR_DATA_CHECK_EVERY_MS = 5 * 60 * 1000
let lastClearDataCheckAt = 0

export const getClearData = createAsyncThunk(
	'getClearData',
	async (history) => {
		lastClearDataCheckAt = Date.now()
		const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
		if (!localStorage.getItem('adoc_clear_cache')) {
			localStorage.setItem('adoc_clear_cache', now)
		}
		if (!localStorage.getItem('adoc_clear_local_storage')) {
			localStorage.setItem('adoc_clear_local_storage', now)
		}
		const clear_cache = localStorage.getItem('adoc_clear_cache')
		const clear_local_storage = localStorage.getItem('adoc_clear_local_storage')
		const response = await fetch(
			`${baseUrl}/api/master-club-clear-data-logs/list`,
			{
				headers: headersDefault(),
			}
		)

		if (response.status !== 200)
			throw new Error(response.message ?? 'GenericError')

		const data = await response.json()

		const willClearLocalStorage =
			data.clear_local_storage && data.created_at > clear_local_storage
		const willClearCache = data.clear_cache && data.created_at > clear_cache

		if (willClearLocalStorage) {
			localStorage.setItem('adoc_clear_local_storage', data.created_at)
			// console.log('adoc_clear_local_storage', data.created_at)
			if (history) history.replace('/logout')
			else window.location.assign('/logout')
		}

		if (willClearCache) {
			localStorage.setItem('adoc_clear_cache', data.created_at)
			// console.log('adoc_clear_cache', data.created_at)
			clearCache(null)
		}

		return data
	},
	{
		condition: () => Date.now() - lastClearDataCheckAt >= CLEAR_DATA_CHECK_EVERY_MS,
	}
)
